import dayjs from 'dayjs';

import * as apiMethods from '../../consts/api/apiMethods';
import {setLvkData, setLvkSettingsData, setLvkStatisticsData, setLvkStatus} from '../../state/ducks/services';
import ApiClient from '../api/clients/apiClient';
import ModulesHostApiClient from '../api/clients/modulesHostApiClient';
import {buildAllHistoryExcelFile} from '../download/downloadService';
import log from '../logger/log';
import {showNotification} from './servicesService';

const getLvkBuildingLists = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_LVK_BUILDING_LISTS,
            action: setLvkData,
        });
    } catch (e) {
        log.error(`getBuildingsList: ${e}`);
    }
};

const getLvkBuildingListsForModal = async () => {
    try {
        const result = await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_LVK_BUILDING_LISTS,
            action: setLvkData,
        });

        return result;
    } catch (e) {
        log.error(`getBuildingsList: ${e}`);
    }
};

const addBuildingToApplied = async ({data, onRequestSuccess}) => {
    await new ApiClient().callPost({
        methodName: apiMethods.SERVICES_LVK_BUILDING_LISTS,
        // mapper: buildingToAppliedMapping,
        requestConfig: {
            data,
        },
        onResponse: onRequestSuccess,
    });
};

const getLvkStatus = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_LVK_STATE,
            action: setLvkStatus,
        });
    } catch (e) {
        log.error(`getLvkStatus: ${e}`);
    }
};

const turnOffLvkDataSending = async ({onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.SERVICES_LVK_OFF,
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`turnOffLvkDataSending: ${e}`);
    }
};

const turnOnLvkDataSending = async ({onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.SERVICES_LVK_ON,
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`turnOnLvkDataSending: ${e}`);
    }
};

const getLvkStatistics = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_LVK_STATISTICS,
            action: setLvkStatisticsData,
        });
    } catch (e) {
        log.error(`getLvkStatistics: ${e}`);
    }
};

const getLvkSettings = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_LVK_SETTINGS,
            action: setLvkSettingsData,
        });
    } catch (e) {
        log.error(`getLvkSettings: ${e}`);
    }
};

const updateLvkSettings = async ({data, onRequestSuccess}) => {
    await new ApiClient().callPost({
        methodName: apiMethods.SERVICES_LVK_SETTINGS,
        requestConfig: {
            data,
        },
        onResponse: onRequestSuccess,
    });

    await new ModulesHostApiClient().callPost({
        methodName: 'schedulers/lvk',
    });
};

const getLvkBuildingStatisticsHistory = async (buildingId, startDate, endDate) => {
    console.log('API Call Params:', {buildingId, startDate, endDate});
    try {
        const response = await new ApiClient().callGet({
            methodName: `modules/lvk/statistics/history/download/building/${buildingId}`,
            requestConfig: {
                params: {
                    startDate,
                    endDate,
                },
            },
        });

        console.log('Response:', response);

        if (!response?.buildingResults || response.buildingResults.length === 0) {
            console.warn('No statistics data found in the response');
            showNotification('Статистика за вибраний період відсутня.', 'warning');
            return;
        }

        const formatDate = (dateString) => (dateString ? dayjs(dateString).format('YYYY-MM-DD') : 'N/A');

        const dataForExcel = response.buildingResults.flatMap((building) => {
            const failedDevices = (building.Result.FailedDevices || []).map((device) => ({
                EventDate: building.EventTs || 'N/A',
                BuildingID: building.Result.BuildingId || 'N/A',
                BuildingAddress: building.Result.BuildingAddress || 'N/A',
                DeviceType: 'FailedDevice',
                DeviceID: device.DeviceID || 'N/A',
                MeterCode: device.MeterCode,
                Value: device.Value || 'N/A',
                Unit: device.Unit || 'N/A',
                Error: device.Error || 'N/A',
                Date: formatDate(device.Date),
                LocalDate: device.LocalDate || 'N/A',
            }));

            const succeedDevices = (building.Result.SucceedDevices || []).map((device) => ({
                EventDate: building.EventTs || 'N/A',
                BuildingID: building.Result.BuildingId || 'N/A',
                BuildingAddress: building.Result.BuildingAddress || 'N/A',
                DeviceType: 'SucceedDevice',
                DeviceID: device.DeviceID || 'N/A',
                MeterCode: device.MeterCode,
                Value: device.Value || 'N/A',
                Unit: device.Unit || 'N/A',
                Error: device.Error || 'N/A',
                Date: formatDate(device.Date),
                LocalDate: device.LocalDate || 'N/A',
            }));

            return [...failedDevices, ...succeedDevices];
        });

        console.log('Data prepared for Excel:', dataForExcel);

        if (dataForExcel.length > 0) {
            const fileName = `LVKBuilding_${formatDate(new Date().toISOString())}.xlsx`;

            buildAllHistoryExcelFile(dataForExcel, fileName);
            console.log(`Excel file "${fileName}" created successfully.`);
        } else {
            console.warn('No valid data to write to Excel');
        }

        return response;
    } catch (e) {
        console.error(`Error in getBuildingStatisticsHistory: ${e.message}`, e);
        throw e;
    }
};

const getLvkHistoryExcelStatistics = async (startDate, endDate) => {
    try {
        console.log('Start Date:', startDate);
        console.log('End Date:', endDate);

        const response = await new ApiClient().callGet({
            methodName: 'modules/lvk/statistics/history/download',
            requestConfig: {
                params: {startDate, endDate},
            },
        });

        if (!response?.Statistics || response.Statistics.length === 0) {
            console.warn('No statistics data found in the response');

            showNotification('Статистика за вибраний період відсутня.', 'warning');
            return;
        }

        const formatDate = (dateString) => (dateString ? dayjs(dateString).format('YYYY-MM-DD') : '-');

        const fileName = `LVKHistory_${formatDate(new Date().toISOString())}.xlsx`;

        const dataForExcel = response.Statistics.flatMap((stat) =>
            stat.Results.flatMap((result) => {
                return result.SucceedDevices.map((device) => ({
                    BuildingID: result.BuildingId || 'N/A',
                    BuildingAddress: result.BuildingAddress || 'N/A',
                    DeviceID: device.DeviceID || 'N/A',
                    Value: device.Value || 'N/A',
                    Unit: device.Unit || 'N/A',
                    MeterCode: device.MeterCode,
                    Error: device.Error || 'N/A',
                    Date: formatDate(device.Date),
                    LocalDate: device.LocalDate || 'N/A',
                }));
            })
        );

        console.log('Data prepared for Excel:', dataForExcel);

        buildAllHistoryExcelFile(dataForExcel, fileName);

        console.log(`Excel file "${fileName}" created successfully.`);

        return response;
    } catch (e) {
        console.error(`Error in getLvkHistoryExcelKteStatistics: ${e.message}`, e);
        return null;
    }
};

export default {
    getLvkBuildingLists,
    addBuildingToApplied,
    getLvkStatus,
    turnOffLvkDataSending,
    turnOnLvkDataSending,
    getLvkSettings,
    updateLvkSettings,
    getLvkStatistics,
    getLvkBuildingListsForModal,
    getLvkHistoryExcelStatistics,
    getLvkBuildingStatisticsHistory,
};
